module.exports = __webpack_public_path__ + "static/media/page18a.ed5e0f48.png";